<app-header>
  @if (!selfHosted) {
    <bit-tab-nav-bar slot="tabs">
      <bit-tab-link
        [route]="(showSubscriptionPageLink$ | async) ? 'user-subscription' : 'premium'"
        >{{ "subscription" | i18n }}</bit-tab-link
      >
      <bit-tab-link route="payment-details">{{ "paymentDetails" | i18n }}</bit-tab-link>
      <bit-tab-link route="billing-history">{{ "billingHistory" | i18n }}</bit-tab-link>
    </bit-tab-nav-bar>
  }
</app-header>

<router-outlet></router-outlet>
